<template>
    <footer>
      <p class="white-text d-flex align-center justify-center" style="height: 100%;">
        Version 0.1.0
      </p>
    </footer>
  </template>

  <script>
  export default {
    name: 'Footer'
  };
  </script>